export default "__VITE_ASSET__e9ab0dec__"